module.exports = __webpack_public_path__ + "img/gy.98839327.svg";